module.exports = __webpack_public_path__ + "static/media/circle-status-failure.b6070dfa.svg";